import React, { useCallback, useLayoutEffect, useState } from "react";
import { Box } from "@material-ui/core";

export const TabMargin = () => {
  const [height, setHeight] = useState();

  const onResize = useCallback(() => {
    const elArr = document.getElementsByClassName("shadow");
    const el = elArr.length && elArr[0];
    const dims = el && el.getBoundingClientRect();
    const height = dims && dims.height;
    setHeight(height);
  }, []);

  // set the event listener on load
  useLayoutEffect(() => {
    onResize();
    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  }, []);

  return <Box height={height} width="100%" />;
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/components/TabMargin.js